export default "__VITE_ASSET__BAB6Wy9F__"